var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('p',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.field.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }